import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import u from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: a = 16, useVw: c, useRem: l, color: o, withColor: n, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const f = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(u, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-jigoufuwu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: c ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-æºææå¡"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: n ? r(o, 0, "#262933") : "#262933",
        datafollowfill: n ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.987 12.701a.9.9 0 0 1 .9-.9h3.816a.9.9 0 0 1 0 1.8H8.887a.9.9 0 0 1-.9-.9Zm.9 3.499a.9.9 0 1 0 0 1.8h3.816a.9.9 0 0 0 0-1.8H8.887Zm12.25.001-.523-.117a.9.9 0 0 1-.666-.624l1.189.741Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.17 4.689c-1.5-.734-3.034-.804-4.237-.072C4.726 5.352 4.1 6.744 4.1 8.401v16.322c0 1.768 1.465 3.177 3.22 3.177h9.262l.036-.001h6.905c1.309 0 2.456-.302 3.265-1.11.808-.81 1.11-1.957 1.11-3.266v-4.171c0-.056 0-.157-.013-.272-.047-1.207-.42-2.141-1.092-2.818-.66-.666-1.512-.986-2.318-1.163l-2.23-.494h-.002l-1.235-.277a.9.9 0 0 0-1.06 1.132l-1.233-.768-1.233-.769v-2.97c0-.793-.289-1.592-.705-2.252-.417-.661-1.013-1.266-1.724-1.614L10.17 4.689ZM5.9 8.4c0-1.224.447-1.928.97-2.246.526-.321 1.38-.402 2.508.15l4.883 2.398c.346.17.711.51.993.957.283.448.428.919.428 1.293V26.1H7.321c-.796 0-1.42-.637-1.42-1.377V8.4Zm15.237 7.8-1.19-.74-1.232-.77-1.233-.768V26.1h6.04c1.067 0 1.658-.248 1.993-.583.335-.335.583-.926.583-1.993v-4.231l-4.961-3.092Zm0 0 .715.16.002.001 2.233.495h.001c.646.142 1.113.356 1.427.672.293.296.545.776.573 1.656a.891.891 0 0 0 .01.108L21.137 16.2Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, E = h;
export {
  E as default
};
